export enum EventFormField {
  UrlSlug = "UrlSlug",
}
